import React, {useContext} from "react";
import {
  Button,
  Col,
  CustomInput, FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader, Row, Collapse, Card, CardBody, UncontrolledCollapse, InputGroupAddon, Form
} from "reactstrap";
import {observer} from "mobx-react-lite";
import {FormattedMessage, useIntl} from "react-intl";
import UtmSelectView from "../../elements/utms/UtmSelectView";
import {StateContext} from "../../../App";
import {useRouterStore} from "mobx-state-router";
import DisableWrapper from "../../../utils/disableWrapper";
import UtmParamaterSelect from "../../elements/utms/UtmParamaterSelect";
import {MinusCircle, PlusCircle} from "react-feather";
import {batchTypesConstatns} from "../../../utils/constants";
import LockButton from "../../../components/elements/batch/LockButton";

const UtmModal = observer(({store, currentState}) => {
  const routerStore = useRouterStore();
  const { params } = routerStore.routerState;

  const intl = useIntl();
  const stateContext = useContext(StateContext);
  // const createCodeViewState = stateContext.rootUiStore.createCodeViewState
  // const editCodeState = stateContext.rootUiStore.editCodeState
  const selectedGroupUUid = stateContext.rootUiStore.groupSelectStore?.selectedGroup?.uuid;
  //const selectedGroupUUid = !params.id? createCodeViewState.groupSelectStore?.selectedGroup?.uuid : editCodeState?.groupSelectStore?.selectedGroup?.uuid
  store.consumeUtmSelect()
  store.utmSelectState.store.setFilterOn(selectedGroupUUid) // filter utms by group
  const isDisabled = store.isView;

  return (
    <Card>
      <CardBody>
        <DisableWrapper isDisabled={isDisabled}>
          <Row>
            <Col sm={3}>
              <FormGroup check>
                <Input name="utm"
                       type="radio"
                       id="customOpen"
                       value={store.customOpen}
                       checked={store.customOpen}
                       onClick={() => {
                         store.setCustomOpen()
                       }}
                />
                <Label check>
                  <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.new.defaultMessage"/>
                </Label>
              </FormGroup>
            </Col>
            {store.customOpen &&
              <>
                <Col sm={6}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend"
                      // label={intl.formatMessage({id: 'createQr.advancedConfigsOptions.modalButtons.autofillForm.defaultMessage'})}
                    >
                    Autofill Form
                      {/*<FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.autofillForm.defaultMessage"/>*/}
                    </InputGroupAddon>
                    <UtmSelectView store={store.utmSelectState} isDisabled={isDisabled}/>
                  </InputGroup>
                </Col>
              </>
            }
            <Col sm={2}>
              <FormGroup check>
                <Input name="utm"
                       type="radio"
                       id="noUtmSelectButton"
                       value={store.noUtmOpen}
                       checked={store.noUtmOpen}
                       onClick={() => {
                         store.setNoneOpen()
                       }}
                       title={
                        currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT ?
                        "Setting None will remove all UTM parameters from the URL" : undefined
                       }

                />
                <Label check
                       title={
                        currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT ?
                        "Setting None will remove all UTM parameters from the URL" : undefined
                       } >
                  None
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row>
          {store.customOpen &&
            <Col className="mt-3">
            <Form>
              <FormGroup row className="mb-2">
                <Label for="campaign" sm={3} className="text-sm-right">Campaign</Label>
                <Col sm={4}>
                  {/*<Input*/}
                  {/*  type="input"*/}
                  {/*  id="campaign"*/}
                  {/*  name="campaign"*/}
                  {/*  invalid={store.utm.isInputInvalid("campaign")}*/}
                  {/*  required*/}
                  {/*  onChange={(data) => { store.utm.updateInput("campaign", data) }}*/}
                  {/*  value={store.utm.campaign}*/}
                  {/*/>*/}
                  <InputGroup>
                    <Input
                      type="input"
                      id="campaign"
                      name="campaign"
                      // invalid={store.utm.isInputInvalid("campaign")}
                      onChange={(data) => { store.utm.updateInput("campaign", data) }}
                      value={store.utm.campaign}
                      disabled={!!store.utm?.utmParametersConfigs?.campaignSelectValue || store.selectVisibility["campaign"] || store.utm.batchEditCampaignNochanges}
                    />
                    {/* Toggle Button Next to Input */}
                    <InputGroupAddon addonType="append">
                      <Button color="link" onClick={() => store.toggleSelectVisibility("campaign")} disabled={!!store.utm.campaign || store.utm.batchEditCampaignNochanges}>
                        {store.selectVisibility["campaign"] ? <MinusCircle/> : <PlusCircle/>}
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
                <Col sm={4}>
                  {store.selectVisibility["campaign"] &&
                    <UtmParamaterSelect store={store?.utmParameterSelectState} utmStore={store.utm}
                                                                             field="campaign" isDisabled={isDisabled}/>}
                </Col>
                {/* remove button only shows when editing a new batch */}
                {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                  <Col sm={1} >
                    <LockButton isDisabled={store.utm.batchEditCampaignNochanges} onReset={store.utm.resetCampaign} onToggle={store.setCampaignInputDisabled} />
                  </Col>
                )}
              </FormGroup>
              <FormGroup row className="mb-2">
                <Label for="source" sm={3} className="text-sm-right">Source</Label>
                <Col sm={4}>
                  <InputGroup>
                    <Input
                      type="input"
                      id="source"
                      name="source"
                      // invalid={store.utm.isInputInvalid("source")}
                      required
                      onChange={(data) => { store.utm.updateInput("source", data) }}
                      value={store.utm.source}
                      disabled={!!store.utm?.utmParametersConfigs?.sourceSelectValue || store.selectVisibility["source"] || store.utm.batchEditSourceNochanges}
                    />
                    {/* Toggle Button Next to Input */}
                    <InputGroupAddon addonType="append">
                      <Button color="link" onClick={() => store.toggleSelectVisibility("source")} disabled={!!store.utm.source || store.utm.batchEditSourceNochanges}>
                        {store.selectVisibility["source"] ? <MinusCircle/> : <PlusCircle/>}
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
                <Col sm={4}>
                  {store.selectVisibility["source"] && <UtmParamaterSelect store={store?.utmParameterSelectState}
                                                                           utmStore={store.utm}
                                                                           field="source" isDisabled={isDisabled}/>}
                </Col>
                {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                  <Col sm={1} >
                    <LockButton isDisabled={store.utm.batchEditSourceNochanges} onReset={store.utm.resetSource} onToggle={store.setSourceInputDisabled} />
                  </Col>
                )}
              </FormGroup>
              <FormGroup row className="mb-2">
                <Label for="medium" sm={3} className="text-sm-right">Medium</Label>
                <Col sm={4}>
                  <InputGroup>
                    <Input
                      type="input"
                      id="medium"
                      name="medium"
                      // invalid={store.utm.isInputInvalid("medium")}
                      required
                      onChange={(data) => { store.utm.updateInput("medium", data) }}
                      value={store.utm.medium}
                      disabled={!!store.utm?.utmParametersConfigs?.mediumSelectValue || store.selectVisibility["medium"] || store.utm.batchEditMediumNochanges}
                    />
                    {/* Toggle Button Next to Input */}
                    <InputGroupAddon addonType="append">
                      <Button color="link" onClick={() => store.toggleSelectVisibility("medium")} disabled={!!store.utm.medium || store.utm.batchEditMediumNochanges}>
                        {store.selectVisibility["medium"] ? <MinusCircle/> : <PlusCircle/>}
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>

                </Col>
                <Col sm={4}>
                  {store.selectVisibility["medium"] && <UtmParamaterSelect store={store?.utmParameterSelectState}
                                                                           utmStore={store.utm}
                                                                           field="medium" isDisabled={isDisabled}/>}
                </Col>
                {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                  <Col sm={1} >
                    <LockButton isDisabled={store.utm.batchEditMediumNochanges} onReset={store.utm.resetMedium} onToggle={store.setMediumInputDisabled} />
                  </Col>
                )}
              </FormGroup>
              <FormGroup row className="mb-2">
                <Label for="term" sm={3} className="text-sm-right">Term</Label>
                <Col sm={4}>

                  <InputGroup>
                    <Input
                      type="input"
                      id="term"
                      name="term"
                      onChange={(data) => { store.utm.updateInput("term", data) }}
                      value={store.utm.term}
                      disabled={!!store.utm?.utmParametersConfigs?.termSelectValue || store.selectVisibility["term"] || store.utm.batchEditTermNochanges}
                    />
                    {/* Toggle Button Next to Input */}
                    <InputGroupAddon addonType="append">
                      <Button color="link" onClick={() => store.toggleSelectVisibility("term")} disabled={!!store.utm.term || store.utm.batchEditTermNochanges}>
                        {store.selectVisibility["term"] ? <MinusCircle/> : <PlusCircle/>}
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
                <Col sm={4}>
                  {store.selectVisibility["term"] && <UtmParamaterSelect store={store?.utmParameterSelectState}
                                                                         utmStore={store.utm}
                                                                         field="term" isDisabled={isDisabled}/>}
                </Col>
                {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                  <Col sm={1} >
                    <LockButton isDisabled={store.utm.batchEditTermNochanges} onReset={store.utm.resetTerm} onToggle={store.setTermInputDisabled} />
                  </Col>
                )}
              </FormGroup>
              <FormGroup row className="mb-2">
                <Label for="content" sm={3} className="text-sm-right">Content</Label>
                <Col sm={4}>
                  <InputGroup>
                    <Input
                      type="input"
                      id="content"
                      name="content"
                      onChange={(data) => { store.utm.updateInput("content", data) }}
                      value={store.utm.content}
                      disabled={!!store.utm?.utmParametersConfigs?.contentSelectValue || store.selectVisibility["content"] || store.utm.batchEditContentNochanges}
                    />
                    {/* Toggle Button Next to Input */}
                    <InputGroupAddon addonType="append">
                      <Button color="link" onClick={() => store.toggleSelectVisibility("content")} disabled={!!store.utm.content || store.utm.batchEditContentNochanges}>
                        {store.selectVisibility["content"] ? <MinusCircle/> : <PlusCircle/>}
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
                <Col sm={4}>
                  {store.selectVisibility["content"] && <UtmParamaterSelect store={store?.utmParameterSelectState}
                                                                            utmStore={store.utm}
                                                                            field="content" isDisabled={isDisabled}/>}
                </Col>
                {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                  <Col sm={1} >
                    <LockButton isDisabled={store.utm.batchEditContentNochanges} onReset={store.utm.resetContent} onToggle={store.setContentInputDisabled} />
                  </Col>
                )}
              </FormGroup>
            </Form>
            </Col>
          }
          </Row>
          <Row className="p-1">
            <Col sm={2}>
              <Button color="secondary" id="cancel-btn" onClick={async () => {
                // editCodeState && editCodeState.modalStore.toggle()
                // createCodeViewState && createCodeViewState.modalStore.toggle()
                currentState.utmModalState.setOpenView()
                currentState.modalStore.toggle()
              }}> <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.cancel.defaultMessage"/> </Button>
            </Col>
            <Col sm={10} className="text-right">
              <Button outline color="primary" onClick={async () => {
                // if (createCodeViewState) {
                //   if (store.noUtmOpen || store.utm.validateUtmModel()) {
                //     createCodeViewState.addUtmToCode()
                //     createCodeViewState.modalStore.toggle()
                //   }
                // }
                // if (editCodeState) {
                //   if (store.noUtmOpen || store.utm.validateUtmModel()) {
                //     editCodeState.addUtmToCode()
                //     editCodeState.modalStore.toggle()
                //   }
                // }
                if (store.noUtmOpen || store.utm.validateUtmModel()) {
                  currentState.addUtmToCode()
                  currentState.modalStore.toggle()
                }
              }}><FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.apply.defaultMessage"/></Button>
            </Col>
          </Row>
        </DisableWrapper>
      </CardBody>
    </Card>

  );
})

export default UtmModal;
